import React from 'react'
import styled from 'styled-components'
import { range } from 'lodash-es'
import { MAX_LIKERT_QUESTION_RESPONSE_OR_RATE, MIN_LIKERT_QUESTION_RESPONSE_OR_RATE } from '../../utilities/helpers'

const DistributionChart = ({ chartData, chartType, title }) => {

  const LABELS = range(MIN_LIKERT_QUESTION_RESPONSE_OR_RATE, MAX_LIKERT_QUESTION_RESPONSE_OR_RATE + 1)

  let values =  LABELS.map((item) => {
    const found = chartData.find((el) => el.label === item)
    return found ? found.count : 0;
  })

  const total = values.reduce((accumulator, currentValue) => {
     return accumulator + currentValue
   },0);
  const maxValue = Math.max(...values);
  const heightMultiplier = total/maxValue;

  const getHeight = (value) => {
    return ((value*100)/total)*heightMultiplier;
  }

  return (
    <ChartContainer>
      <ChartTitle>{title}</ChartTitle>
      <Bars>
        {values.map((value, index) => {
          return (
            <BarContainer key={index}>
              <Value>{value}</Value>
              <Bar style={{flexBasis: `${getHeight(value)}%`}} />
            </BarContainer>
          )
        })}
      </Bars>
      <DashedLine />
      <Labels>
        {LABELS.map((label, index) => {
          return (
            <span key={index}>
              {chartType === "result" ?
                `${index * 25}%`
              :
                label
              }
            </span>
          )
        })}
      </Labels>
    </ChartContainer>
  )
}

export default DistributionChart;

const ChartTitle = styled.h6`
  text-align: center;
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 500;
  
  * & {
    font-size: 14px;
    font-weight: 500;
  }
`;

const ChartContainer = styled.div`
  width: 100%;
  max-width: 400px;
  padding: 0 10px;
`;

const Bars = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 25px;
`;

const BarContainer = styled.div`
  position: relative;
  width: 30px;
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Bar = styled.div`
  position: relative;
  height: auto;
  width: 100%;
  background-color: #F58220;
  border-radius: 4px 4px 0px 0px;
  flex: 0 0 100%;
`;

const Value = styled.div`
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #000;
  font-weight: 600;
`;

const DashedLine = styled.div`
  width: calc(100% + 20px);
  margin-left: -10px;
  height: 1px;
  border-top: 1px dashed #5F7D95;
`;

const Labels = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 500;
  color: #5F7D95;
  padding-top: 4px;
  
  span {
    display: block;
    width: 30px;
    text-align: center;
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/distributionChart.js